module.exports = __webpack_public_path__ + "static/media/TT-Commons-Medium.fec750d6.otf";